import React from "react";
import { Box, Typography } from "@bca/ui-library";
import styled from "styled-components";
import css from "@styled-system/css";

import ReportItem from "./mechanicalReport/ReportItem";
import { CategoryMapping } from "../vehicleDetails/vehicle-details-props.type";
import { ReportDetailTypes } from "./mechanicalReport/mechanical-report.types";
import SlashWrenchSVG from "./Icons/MechanicalReportIcons/SlashWrenchSVG";
import WrenchSVG from "./Icons/MechanicalReportIcons/WrenchSVG";
import KeyDecisionMakerContainer from "./KeyDecisionMakerContainer";
import { LinkElement } from "./mechanicalReport/styledElements/LinkElement";
import { ClaimsText } from "./mechanicalReport/styledElements/ClaimsText";

interface MechanicalReportProps {
  reportType?: ReportDetailTypes;
  anchorLink?: string;
  categoryMapping: CategoryMapping[] | null;
}

const reportTitle = {
  EssentialChecks: "BCA Essential Check",
  Standard: "BCA Assured",
  ElectricHybrid: "BCA Assured EV/Hybrid",
  FullInspection: "128 Vehicle Inspection",
  NoReport: "No Report",
};

const StyledReportSummary = styled(Box)`
  display: flex;
  width: 100%;
  ${css({
    gap: ["10px", "4px", "10px"],
    justifyContent: ["start", "center"],
  })}
`;

const MechanicalReport: React.FunctionComponent<MechanicalReportProps> = ({
  reportType,
  anchorLink,
  categoryMapping,
}) => {
  const categoryKeys = [
    "Engine",
    "Gearbox",
    "Fluids",
    "WarningLights",
    "Other",
    "Wheel&Tyres",
  ];

  const sortedCategoryMapping = categoryMapping?.sort(
    (a, b) => categoryKeys.indexOf(a.key) - categoryKeys.indexOf(b.key)
  );

  const title = reportTitle[reportType];

  const MechanicalReport = (reportType: ReportDetailTypes) => {
    switch (reportType) {
      case "NoReport":
        return (
          <KeyDecisionMakerContainer>
            <SlashWrenchSVG />
            <Typography variant="body-small" color="grey-blue" m={0}>
              {title}
            </Typography>
          </KeyDecisionMakerContainer>
        );
      case "FullInspection":
        return (
          <KeyDecisionMakerContainer>
            <WrenchSVG />
            <LinkElement
              anchorLink={anchorLink}
              reportType={reportType}
              title={title}
              categoryMapping={categoryMapping}
            />
            <ClaimsText />
          </KeyDecisionMakerContainer>
        );
      default:
        return (
          <>
            {categoryMapping?.length > 0 ? (
              <KeyDecisionMakerContainer>
                <StyledReportSummary>
                  {sortedCategoryMapping.map((category, index) => {
                    return (
                      <ReportItem
                        key={index}
                        categoryKey={category.key}
                        severityCode={category.severityCode}
                        numberOfAmber={category.numberOfAmber}
                        numberOfRed={category.numberOfRed}
                      />
                    );
                  })}
                </StyledReportSummary>
                <LinkElement
                  anchorLink={anchorLink}
                  reportType={reportType}
                  title={title}
                  categoryMapping={categoryMapping}
                />
                {reportType === "EssentialChecks" && <ClaimsText />}
              </KeyDecisionMakerContainer>
            ) : null}
          </>
        );
    }
  };

  return <>{MechanicalReport(reportType)}</>;
};

export default MechanicalReport;
